import { Action, Reducer, State } from '../use_candidate_profile';

export const scorecardReducer: Reducer = (state: State, action: Action) => {
  switch (action.type) {
    case 'getScorecards': {
      return {
        ...state,
        scorecards: action.payload,
      };
    }
    default:
      return state;
  }
};
